import { z } from 'zod'
import type { McpAccessLevel } from './mcp-access-level.enum.js'

/**
 * An organization's cap on AI apps over MCP, set by its Owners. Every
 * organization starts at `test_only`; raising it happens in the dashboard.
 */
export const MCP_ORG_SETTINGS = ['off', 'test_only', 'live_read', 'full'] as const

export const mcpOrgSettingSchema = z.enum(MCP_ORG_SETTINGS)

export type McpOrgSetting = z.infer<typeof mcpOrgSettingSchema>

export const PRISMA_MCP_ORG_SETTINGS = ['OFF', 'TEST_ONLY', 'LIVE_READ', 'FULL'] as const

export type PrismaMcpOrgSetting = (typeof PRISMA_MCP_ORG_SETTINGS)[number]

export const MCP_ORG_SETTING_FROM_PRISMA = {
  OFF: 'off',
  TEST_ONLY: 'test_only',
  LIVE_READ: 'live_read',
  FULL: 'full',
} as const satisfies Record<PrismaMcpOrgSetting, McpOrgSetting>

export const MCP_ORG_SETTING_TO_PRISMA = {
  off: 'OFF',
  test_only: 'TEST_ONLY',
  live_read: 'LIVE_READ',
  full: 'FULL',
} as const satisfies Record<McpOrgSetting, PrismaMcpOrgSetting>

const SETTING_ORDER: Record<McpOrgSetting, number> = { off: 0, test_only: 1, live_read: 2, full: 3 }

/** Whether `next` is a lower setting than `current` (only lowering is allowed over MCP). */
export function isLowerSetting(next: McpOrgSetting, current: McpOrgSetting): boolean {
  return SETTING_ORDER[next] < SETTING_ORDER[current]
}

/** The most access the setting allows a connection; null when MCP is off. */
export function settingCap(setting: McpOrgSetting): McpAccessLevel | null {
  switch (setting) {
    case 'off':
      return null
    case 'test_only':
      return 'test_only'
    case 'live_read':
      return 'live_read'
    case 'full':
      return 'live'
  }
}
